

import ElementModelManager from "../../DataManagers/ElementModelManager.js";
import ClashModelManager from "../ClashModelManager.js";


let manager = new ElementModelManager()
let clashmanager = new ClashModelManager();

export function exportData(format) {

    let elements;
    if (format === "csv") {
        elements = manager.getModels();

        if (!Array.isArray(elements) || elements.length === 0) {
            console.error("No data to export.");
            return;
        }
        exportToCSV(elements);
    } else if (format === "json") {
        elements = clashmanager.setClashListForExport();
        //console.log(elements)
        if (!Array.isArray(elements) || elements.length === 0) {
            console.error("No data to export.");
            return;
        }

        exportToJSON(elements);
    } else {
        console.error("Invalid format specified. Use 'csv' or 'json'.");
    }
}

function exportToCSV(elements) {
    const headers = [
        "IFCSchema", "FilepathName", "FileName", "FileType", "IFCCategory", "IFCSubtype", "OBCategory",
        "ElementID", "PropertySet", "PropertyType", "ParameterName", "Value", "OBParameter"
    ];

    const csvRows = [];
    csvRows.push(headers.join(",")); // Add headers

    elements.forEach(element => {
        element.parameters.forEach(param => {
            const row = [
                `"${element.IFCSchema}"`,
                `"${element.filePathName}"`,
                `"${element.fileName}"`,
                `"${element.filetype}"`,
                `"${element.type}"`,
                `"${element.subtype}"`,
                `"${element.category}"`,
                `"${element.id}"`,
                `"${param.propertyset}"`,
                `"${param.type}"`,
                `"${param.name}"`,
                `"${param.value}"`,
                `"${''}"` // Optional OBParameter
            ];
            csvRows.push(row.join(","));
        });
    });

    downloadFile(csvRows.join("\n"), "elements.csv", "text/csv");
}

function exportToJSON(elements) {
    const jsonString = JSON.stringify(elements, null, 2);
    downloadFile(jsonString, "clashlist.json", "application/json");
}

function downloadFile(content, filename, mimeType) {
    const blob = new Blob([content], { type: mimeType });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}